exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".regulatory-data-menu {\n  display: flex;\n  justify-content: center; }\n  @media (min-width: 500px) {\n    .regulatory-data-menu .Form {\n      width: 75%; } }\n  @media (min-width: 800px) {\n    .regulatory-data-menu .Form {\n      width: 50%; } }\n", ""]);

// exports
